import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import SaulDrCircle from '@/assets/imgs/saul-dr-circle.png';
import MakruraLogo from '@/assets/imgs/makrura.png';
import GamesLogo from '@/assets/imgs/games.png';
import PalaRiffleLogo from '@/assets/imgs/paladin.png';
import NewsLogo from '@/assets/imgs/news.webp';
import Planet from '@/assets/imgs/planet.png';
import { MainDrawerNavigationLink } from './MainNavbar.model';
import { computed, Ref, ref, watch } from 'vue';
import { useDisplay } from 'vuetify';
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'MainNavbar',
  setup(__props) {

const authStore = useAuthStore();
authStore.hydrateFromStorage();

const { width } = useDisplay();
const isExpanded = ref(false);
const isMobile = computed(() => width.value < 1000);
const drawer = ref(!isMobile.value);
const router = useRouter();

watch(isMobile, (mobile) => {
  drawer.value = !mobile;
});

const navLinks: Ref<MainDrawerNavigationLink[]> = computed(() => [
  {
    title: 'DR University',
    to: '/dru',
    customIcon: SaulDrCircle,
    alt: 'DR University Logo',
    location: 'top',
  },
  {
    title: 'PR University',
    to: '/pru',
    customIcon: PalaRiffleLogo,
    alt: 'PR University Logo',
    location: 'top',
  },
  {
    title: 'Ape News',
    to: '/news',
    customIcon: NewsLogo,
    alt: 'News Logo',
    location: 'top',
  },
  {
    title: 'Games',
    to: '/games',
    customIcon: GamesLogo,
    alt: 'Games Logo',
    location: 'top',
  },
  {
    title: 'GeoGuesser',
    to: '/geoguesser',
    location: 'top',
    customIcon: Planet,
  },
  {
    title: 'CMS Dashboard',
    to: '/cms',
    icon: 'mdi-view-dashboard',
    location: 'bottom',
    hide: !authStore.isAuthenticated,
  },
  {
    title: 'Login',
    to: '/login',
    icon: 'mdi-login',
    location: 'bottom',
    hide: authStore.isAuthenticated,
  },
  {
    title: 'Logout',
    icon: 'mdi-logout',
    location: 'bottom',
    customFunction: () => logout(),
    hide: !authStore.isAuthenticated,
  },
]);

const logout = () => {
  authStore.removeToken();
  router.push('/login');
};

const topLinks = computed(() => navLinks.value.filter((link) => link.location === 'top' && !link?.hide));
const bottomLinks = computed(() => navLinks.value.filter((link) => link.location === 'bottom' && !link?.hide));

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isMobile.value)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          icon: "mdi-menu",
          class: "ma-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
      location: "left",
      permanent: !isMobile.value,
      temporary: isMobile.value,
      "expand-on-hover": !isMobile.value,
      rail: !isMobile.value,
      "rail-width": 72,
      width: isMobile.value ? _unref(width) + 1 : undefined,
      onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (!isMobile.value && (isExpanded.value = true))),
      onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (!isMobile.value && (isExpanded.value = false)))
    }, {
      prepend: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["drawer-header", { 'drawer-header-authenticated': _unref(authStore).isAuthenticated }])
        }, [
          _createVNode(_component_v_img, {
            src: _unref(MakruraLogo),
            alt: "Makrura Logo",
            width: "48",
            height: "48",
            class: "rounded-full"
          }, null, 8, ["src"]),
          _createElementVNode("span", {
            class: _normalizeClass([{ hide: !isExpanded.value && !isMobile.value }, "mt-2 text-base font-medium whitespace-nowrap"])
          }, " makrura.com ", 2),
          (_unref(authStore).isAuthenticated)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass([{ hide: !isExpanded.value && !isMobile.value }, "text-sm text-gray-500 mt-1 whitespace-nowrap"])
              }, " Hello " + _toDisplayString(_unref(authStore).getLogin) + "! ", 3))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      append: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottomLinks.value, (link) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: link.title,
                to: link.to,
                onClick: 
            () => {
              link.customFunction?.();
              if (isMobile.value) drawer.value = false;
            }
          ,
                class: _normalizeClass({ 'cursor-pointer': !!link.customFunction }),
                "active-class": "active-link"
              }, {
                prepend: _withCtx(() => [
                  (link.customIcon)
                    ? (_openBlock(), _createBlock(_component_v_img, {
                        key: 0,
                        src: link.customIcon,
                        alt: link.alt,
                        width: "40",
                        height: "40"
                      }, null, 8, ["src", "alt"]))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: 40
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.icon), 1)
                        ]),
                        _: 2
                      }, 1024))
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(link.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["to", "onClick", "class"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, { class: "mt-10" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topLinks.value, (link) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                class: "mb-3",
                key: link.title,
                to: link.to,
                "active-class": "active-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isMobile.value && (drawer.value = false)))
              }, {
                prepend: _withCtx(() => [
                  (link.customIcon)
                    ? (_openBlock(), _createBlock(_component_v_img, {
                        key: 0,
                        src: link.customIcon,
                        alt: link.alt,
                        width: "40",
                        height: "40"
                      }, null, 8, ["src", "alt"]))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: 40
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.icon), 1)
                        ]),
                        _: 2
                      }, 1024))
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "image-link-text" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(link.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "permanent", "temporary", "expand-on-hover", "rail", "width"])
  ], 64))
}
}

})